import React, { useState, useCallback, useContext, ReactNode } from "react";
import { DropdownMenu } from "../DropdownMenu";
import { useTranslation } from "react-i18next";
import { HMIContext } from "../../contexts/HMIContext/HMIContext";
import { SelectChangeEvent } from "@mui/material/Select/Select";
import { IViewDropdownProps } from "./ViewDropdownInterfaces";

export enum ViewOptionsEnum {
    summary = "summary",
    details = "details",
}

export const ViewDropdown = ({ bigSize }: IViewDropdownProps) => {
    const { t, i18n } = useTranslation();
    const { handleView, view } = useContext(HMIContext);
    const [dropdownValue, setDropdownValue] = useState(view ? view : t(ViewOptionsEnum.summary));

    const tKeys = {
        base: "view_dropdown",
        title: "title",
        optionsHolder: "view_options",
        key: "option",
    };

    const viewOptions =
        i18n.language.slice(0, 2) === "en"
            ? [
                  { id: ViewOptionsEnum.summary, name: "Summary" },
                  { id: ViewOptionsEnum.details, name: "Details" },
              ]
            : i18n.language.slice(0, 2) === "fr"
            ? [
                  { id: ViewOptionsEnum.summary, name: "Résumé" },
                  { id: ViewOptionsEnum.details, name: "Détails" },
              ]
            : [
                  { id: ViewOptionsEnum.summary, name: "Resumen" },
                  { id: ViewOptionsEnum.details, name: "Detalles" },
              ];

    const handleChange = useCallback(
        (event: SelectChangeEvent<string>, child: ReactNode): void => {
            setDropdownValue(event?.target.value);
            handleView(event?.target.value as ViewOptionsEnum);
        },
        [handleView],
    );

    return (
        <div>
            <DropdownMenu
                dropdownValue={dropdownValue}
                handleChange={handleChange}
                tKeys={tKeys}
                options={viewOptions}
                bigSize={bigSize}
            />
        </div>
    );
};
